import { RoundingType } from "src/enums";

export const decimalWithRoundingToDown = {
  decimalPlaces: 2,
  roundingType: RoundingType.DOWN,
};
